import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
body {
/* @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,200&display=swap'); */
margin: 0;
padding: 0;
list-style:none;
text-decoration:none;
box-sizing:border-box;
font-family:'Monserrat',sans-serif ;
text-decoration: none;
list-style: none;
width: 100%; 
}

`;

export default GlobalStyles
